import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../Services/api";
import "./detalhes.css";
import { toast } from "react-toastify";

function Filme() {
  const{id} = useParams();
  const navigate = useNavigate (); 
  const [filme, setFilme] = useState({}); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadFilme() {
      await api.get(`/movie/${id}`, {
        params: {
          api_key: "51fbcb314004a461c9dae6099bbc6134",
          language: "pt-br",
        }
      })
      .then((response) => {
        setFilme(response.data);
        setLoading(false);
      })
      .catch(() => {
        navigate("/", {replace: true});
        return;
      })
    }

    loadFilme();

    return () => {
      console.log("Componente desmontado");
    }

  }, [navigate, id]);

  //*****ESTUDAR*******
  function salvarFilme(){
    
    const minhaLista = localStorage.getItem('@primeflix'); 
    let filmesSalvos = JSON.parse(minhaLista) || [];
    const hasFilme = filmesSalvos.some((filmesSalvo) => filmesSalvo.id === filme.id)

    if (hasFilme){
      toast.warn("Esse filme já está na sua lista");
      return;
    }

    filmesSalvos.push(filme);
    localStorage.setItem('@primeflix', JSON.stringify(filmesSalvos));
    toast.success("Filme salvo com sucesso");
  }

  if(loading){
    return(
      <div className="filme-info">
        <h2>Carregando detalhes...</h2>
      </div>
    )
  }

  return (
    <div className="filme-info">
      <img src={`https://image.tmdb.org/t/p/original/${filme.backdrop_path}`} alt={filme.title} />
      <h1>{filme.title}</h1>
      <h3>Sinopse</h3>
      <p>{filme.overview}</p>
      <strong>Avaliação: {filme.vote_average} / 10</strong>

      <div className="area-buttons">
        
        <button onClick={salvarFilme}>
          Salvar
        </button>

        <button>  
          <a target="blank" rel="external" href={`https://www.youtube.com/results?search_query=${filme.title} trailer`}>
            Trailer
          </a>
        </button>
      </div>

    </div>
  );
}

export default Filme;